module.exports = __webpack_public_path__ + "static/portfolio_gallery_21-c00682a62d7ba01c59974ce5231c1d72.jpg";